import React from 'react';
import { Dialog, Grid, DialogProps } from '@material-ui/core';
import { Paper, Text, PrimaryButton } from 'library';
import CloseButton from 'reusableComponents/CloseButton';
import { useWidth } from 'reusableComponents/useWidth';

interface IProps extends DialogProps {
    onClose: () => void;
    feature: string;
}

export default function ComingSoonGroupDialog({ onClose, feature, ...props }: IProps) {
    const breakpoint = useWidth();

    const fullScreen = breakpoint === 'xs';

    return (
        <Dialog {...props} maxWidth={'sm'} fullScreen={fullScreen} onClose={onClose}>
            <Paper elevation={0}>
                <Grid container>
                    <CloseButton onClose={onClose} />
                    <Grid container item direction="column" justify="center" style={{ paddingTop: 20 }}>
                        <Text variant="display">{feature} groups coming soon!</Text>
                        <Text variant="h2" textStyle={{ paddingTop: 20 }}>
                            Interacting with other families and providers is becoming easier than ever! Soon, you will
                            be able to create or join groups to engage with the community!
                        </Text>
                        <Grid item style={{ paddingTop: 20, width: 100 }}>
                            <PrimaryButton onClick={() => onClose()}>Great!</PrimaryButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </Dialog>
    );
}
